// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"55ae7996","453":"ed8f90f0","455":"16793a51","977":"1e17873d"}[chunkId] + ".chunk.js";
};